import { ApolloError, LazyQueryResultTuple, QueryResult } from '@apollo/client';
import { useContext, useEffect, useRef } from 'react';
import { GlobalErrorModalContext } from 'providers/GlobalErrorModalProvider';
const isQueryLazy = (
  // eslint-disable-next-line
  query: LazyQueryResultTuple<any, any> | QueryResult<any, any>
  // eslint-disable-next-line
): query is LazyQueryResultTuple<any, any> => {
  return Array.isArray(query);
};
// eslint-disable-next-line
export const useRequiredQueries = (queries: (LazyQueryResultTuple<any, any> | QueryResult<any, any>)[]) => {
  const errorDetected = useRef(false);
  const { setError } = useContext(GlobalErrorModalContext);

  useEffect(() => {
    if (errorDetected.current) {
      return;
    }

    let error: ApolloError | undefined;
    queries.forEach(query => {
      if (isQueryLazy(query) && query[1].error) {
        error = query[1].error;
      } else if (!isQueryLazy(query) && query.error) {
        error = query.error;
      }
    });
    if (error !== undefined) {
      errorDetected.current = true;
      setError(error);
    }
  }, [queries, setError]);
};
